import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, OnInit, ViewChild  } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent, Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { SelfExcludeAcknowledgement } from "src/app/interfaces/self-exclude-acknowledgement";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { ConfigService } from "src/app/services/config/config.service";
import { LogoutService } from "src/app/services/logout/logout.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { ResponsibleGamingService } from "src/app/services/responsible-gaming-service/responsible-gaming.service";
import { TrackService } from "src/app/services/track/track.service";
import { ExcludeOption } from "./util-classes/ExcludeOption";
import { SiteContentInterface } from "src/app/interfaces/sitecontent-interface";
import { SiteContentService } from "src/app/services/sitecontent/sitecontent.service";
import { SiteContentModel } from "src/app/models/sitecontent-model";
import { lastValueFrom } from "rxjs";

@Component({
  selector: 'app-self-exclude',
  templateUrl: './self-exclude.component.html',
  styleUrls: ['./self-exclude.component.scss'],
})

export class SelfExcludeComponent implements OnInit, AfterViewInit {

    @ViewChild(IonContent, { static: false }) content: IonContent;

    public confirm: boolean = false;
    public error = null;
    public environmentName: string;
    public excludeOptions: ExcludeOption[];
    public excludedYears: string;
    public isMobile: boolean = false;
    //This is Acknowledgement checkbox config varibale
    public labels: any = [];
    //This is whole page config varibale
    public configLabels: any = [];
    public state: string;

    public selfExcludeForm: FormGroup;
    public acknowledgements: FormArray;
    public onBackCallback: Function;

    public dgeLink: string;
    public dgeLinkName: string;
    public councilLink: string;
    public councilLinkName: string;
    public councilLinkText: string;
    //public labels: SiteContentInterface;
    public isIos: boolean = false;

    constructor(
      private formBuilder: FormBuilder,
      public appLinks: AppLinksService,
      public config: ConfigService,
      public http: HttpClient,
      public logOutService: LogoutService,
      public navigator: Navigator,
      public responsibleGamingService: ResponsibleGamingService,
      private appLinksService: AppLinksService,
      public successMessageService: SuccessMessageService,
      public platform:Platform,
      private track:TrackService,
      private siteContentService: SiteContentService
    ){
      this.successMessageService.clearMessage();
      this.environmentName = this.config.getState();
      this.configLabels = new SiteContentModel();
      this.detectMobile();
    }

    ngOnInit(): void {
      this.onBackCallback = this.onBack.bind(this);
      this.isIos = this.platform.is("ios");

      const appConfig: any = this.config.getConfig();
      try {
        this.excludeOptions = JSON.parse(appConfig.FEATURE_SELF_EXCLUDE_TERM)
      }
      catch {
        this.excludeOptions = [];
      }
      const selfAck: string = appConfig.FEATURE_SELF_EXCLUDE_ACKNOWLEDGMENTS;

      this.dgeLink = appConfig.DGE_LINK;
      this.dgeLinkName = appConfig.DGE_LINK_NAME;
      this.councilLink = this.config.getConfig()?.COUNCIL_LINK;
      this.councilLinkName = this.config.getConfig().COUNCIL_LINK_NAME || "Mental Health & Addiction Treatment Services | Connex Ontario";
      this.councilLinkText = this.config.getConfig().COUNCIL_LINK_TEXT || "If you need help you can visit the";
      if(selfAck){
        this.getSelfExcludeAcknowledgmentsFromAssets(selfAck).then((value) => {
            this.labels = value;
            this.loadForm(this.labels);
        });
      }

      if(!selfAck) this.loadForm([]);
        this.logPlayerVisit();
    }

      // will log customer visit for self exclusion in the backend
    logPlayerVisit() {
      this.track.trackPage("self_exclusion_page").subscribe({
        error: (error) => { console.error("Error: ", error) }
      });
    }

    ngAfterViewInit(){
      this.siteContentService.loadConfig(this.config.getConfig().FEATURE_SELF_EXCLUDE_CONFIG) //  "self_exclude.nj"
      .then((response: SiteContentInterface) => {
        this.configLabels = response
      })
    }

    ionViewWillLeave(){
      this.successMessageService.clearMessage();
    }


    async getSelfExcludeAcknowledgmentsFromAssets(self_exclude_acknowledgments_url: string) {
      return await lastValueFrom(this.http.get<SelfExcludeAcknowledgement[]>(self_exclude_acknowledgments_url));
    }

    private loadForm(data?): void{
      this.selfExcludeForm = this.formBuilder.group({
        excludePeriod: new FormControl('', [Validators.required]),
        pin: new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern('^[0-9]*')]),
        acknowledgements: this.formBuilder.array(this.createItems(data))
      });

      this.checkValidations();

      //Adding Link after labels are fetched from JSON with 2 seconds delay
      setTimeout(() => {
       this.ackLabelLink();
      }, 2000);
    }

    private checkValidations(){
      if(this.labels.length > 0){
        this.selfExcludeForm.updateValueAndValidity();
      }
    }

    protected detectMobile() {
      if (this.platform.is('mobile')) {
          this.isMobile = true;
      } else {
          this.isMobile = false;
      }
    }

    private createItems(items?: any): Array<any> {
      const array = [];
      items.forEach(() => {
          array.push(this.formBuilder.group({
              acknowledgement: new FormControl(false, [Validators.requiredTrue])
          }))
      });
      return array;
    }

    //This doesn't work propery since it will check for all dynamic content and will generate multiple calls click eventListner
    /*
    ngAfterViewChecked (){
      if(this.bindFunction){
        let labelItem = document.getElementsByClassName('wp-link') ;
        if(labelItem) {
         for (var i = 0; i < labelItem.length; i++) {
         labelItem[i].addEventListener('click', this.openWPPage.bind(this));
         }
        }
      }
    }*/

    public ackLabelLink(){
      const labelItem = document.getElementsByClassName('wp-link') ;
      if(labelItem) {
       for (let i = 0; i < labelItem.length; i++) {
        labelItem[i].addEventListener('click', this.openWPPage.bind(this));
       }
      }
    }

    public openPage(page) {
      return this.navigator.navigateTo(page, { multipleModals: true });
    }

    public onSelfExclude(){
      this.successMessageService.clearMessage();
      this.error = null;
      this.selfExcludeForm.value;
      this.confirm = true;
      this.excludedYears = this.selfExcludeForm.value.excludePeriod;
    }

    public confirmSelfExclude(){
      this.responsibleGamingService.setSelfExclude(this.selfExcludeForm.value).subscribe({
        next: (response: any) => {
          if (response && !!response.result ) {
            this.navigator.dismiss();
            this.navigator.openPopover("PopoverSelfExcludeComponent","",'standard-popover self-exclude');
          }
          this.content.scrollToTop(10);
        },
        error: (error) => {
          this.content.scrollToTop(10);
          this.confirm = false;
          switch (error.getErrorCode().toUpperCase()) {
            case 'INVALID_PIN_NUMBER':
                error.setErrorMessage('Invalid PIN Number. Please try again or contact customer support.');
                break;
            case 'INVALID_SSN_NUMBER':
              error.setErrorMessage('Invalid Social Security Number. Please try again or contact customer support.');
              break;
            default:
                error.setErrorMessage('An error has occured. Please try again.');
                break;
          }
          this.error = error;
        }
      });
    }

    public onCancel(): void{
      // cancel action means close the dialog
      this.navigator.dismissAll();
    }

    onSetLimits() {
      this.navigator.navigateTo("SetDepositLimitsComponent", { multipleModals: true });
      return false;
    }

    public goToGamingcontrolboard(){
      const url = this.config.getConfig().FEATURE_BOARD_EXCLUSION_SITE_URL;
      return this.appLinks.openExternalPage(url);
    }

    goToCouncilLink() {
      this.appLinks.openExternalPage(this.councilLink);
      return false;
    }

    goToDgeLink() {
      this.appLinks.openExternalPage(this.dgeLink);
      return false;
    }

    public onClickResend(){
      this.successMessageService.clearMessage();
      this.error = null;
      this.responsibleGamingService.callResendPin().subscribe({
        next: (response: any) => {
          if (response.result == 1) {
              this.successMessageService.setMessage("We have sent your Personal Identification Number (PIN) to your email address.");
          }
          this.content.scrollToTop(10);
        },
        error: (error) => {
          this.content.scrollToTop(10);
          error.setErrorMessage('There was an issue trying to send your Personal Identification Number (PIN) to your email address. Please contact customer support.')
        }
      });
    }

    public onBack(){
      if(this.confirm) {
        this.confirm = false;
        setTimeout(() => {
          this.ackLabelLink();
         }, 2000);
      } else {
        this.navigator.back();
      }
    }

    public openWPPage(){
      const waiverLink = this.config.getConfig().SELF_EXCLUDE_WAIVER_WP_URL ? this.config.getConfig().SELF_EXCLUDE_WAIVER_WP_URL : '/waiver-and-release/'
      this.appLinksService.openPopover(waiverLink,'WAIVER AND RELEASE');
    }

    goToAGCO(){
      const url = "https://www.agco.ca/";
      return this.appLinks.openExternalPage(url);
    }

    goToAGCOSelfExclude(){
      const link = this.config.getConfig().FEATURE_SELF_EXCLUDE_LINK || "https://www.agco.ca/self-exclusion-and-breaks-play";
      return this.appLinks.openExternalPage(link);
    }


    /**
     *
     * @todo Remove this and replace with proper config
     */
    public showPGCBMessage() {
      return (this.config.getConfig().FEATURE_APP_STATE_IDENTIFIER.toLowerCase() == 'pennsylvania');
    }
}
